(function () {
  //防止程式重複初始化
  if (window.__woSkyviewerInit) {
    if (typeof window.__woSkyviewerInitSections === "function")
      window.__woSkyviewerInitSections(document);
    return;
  }
  window.__woSkyviewerInit = true;

  /* Pure FOV / overlay math. stageMm = the largest image circle or sensor frame span.
     Sky FoV spans that width so the circle and FOV guides share one clipped stage. */
  /* Breathing room around the largest image circle so it never touches the frame (a
     touching circle shows the mask's dark background fill as a black band) AND the mask
     feather always has room to fade out before the frame clips it. Margin = BASE + the
     merchant's feather, so low softness keeps a big sky disc and high softness only then
     shrinks the circle to host the wider fade. No canvas rescale — the sky, mask and SVG
     all ride one scale (stageMm), so they stay aligned; the trade is that changing the
     softness setting re-zooms the whole field (fine: it's a per-section setting). */
  var STAGE_MARGIN_BASE = 0.015;
  //根據尺寸跟焦距計算視野mm等於imageCircleMm,f代表焦距
  function fovForMm(mm, f) {
    return (2 * Math.atan(mm / 2 / f) * 180) / Math.PI;
  }
  //天空 fov 直接對應整個舞台跨距 stageMm,圈在其中按 mm 比例落位,不需額外 padding
  function lockedFov(m, stageMm) {
    return fovForMm(stageMm, m.focalLengthMm);
  }
  //計算成像圈佔舞台的比例,並轉換成%
  function circleEdgePct(m, stageMm) {
    return (m.imageCircleMm / stageMm) * 100;
  }
  /* A sensor is "supported" when the image circle covers its diagonal. Derived from
     image_circle so products only need focal_length + image_circle metafields. */
  //這裡是計算 哪一個感光元件是實現或虛線
  function supportedFormats(imageCircleMm, sensors) {
    return Object.keys(sensors).filter(function (key) {
      var s = sensors[key];
      var diagonalMm = Math.sqrt(s.w * s.w + s.h * s.h);
      var thresholdMm = Math.floor(diagonalMm);
      return imageCircleMm >= thresholdMm;
    });
  }

  function maxSensorSpanMm(sensors, maxCircle) {
    return Math.max.apply(
      null,
      Object.keys(sensors).map(function (key) {
        if (key === "Medium-Format" && maxCircle < 47) return 0;
        var s = sensors[key];
        return Math.max(s.w, s.h);
      }),
    );
  }

  //赤經赤緯字串 "ra dec" → {ra, dec}
  function parseTarget(s) {
    var parts = String(s || "")
      .trim()
      .split(/\s+/);
    return { ra: parseFloat(parts[0]) || 0, dec: parseFloat(parts[1]) || 0 };
  }

  //索引安全處理
  function clampIndex(i, len) {
    if (!Number.isFinite(i)) return 0;
    return Math.min(Math.max(Math.trunc(i), 0), len - 1);
  }

  //星空背景與感光元件設定
  var SKY_CFG = {
    //赤經赤緯 (M42 / Orion Nebula center)
    target: "83.82208 -5.39111",
    // Survey id resolved by the local sky engine to the CDS alasky DSS colour root.
    survey: "CDS/P/DSS2/color",
    // Same DSS2 colour HiPS (JPEG, CORS *) used when the primary root fails to paint.
    fallbackHipsRoot: "https://hips.telescopius.com/DSS/DSSColor",
    defaultIndex: 0,
    sensors: {
      "Medium-Format": {
        label: "Medium Format",
        short: "Medium-Format",
        w: 44,
        h: 33,
      },
      "Full-Frame": {
        label: "Full-Frame",
        short: "Full-Frame",
        w: 36,
        h: 24 },
      "APS-C": {
        label: "APS-C",
        short: "APS-C",
        w: 23.5,
        h: 15.6 },
      "Micro-Four-Thirds": {
        label: "M4/3",
        short: '4/3"',
        w: 17.3,
        h: 13.0,
      },
      "One-Inch": { label: "1-inch", short: '1"', w: 13.2, h: 8.8 },
      "Planetary-1-2-8": {
        label: '1/2.8" Planetary',
        short: '1/2.8"',
        w: 5.6,
        h: 3.2,
      },
    },
  };

  // Pre-paint tile errors / ms before the viewer rebuilds on SKY_CFG.fallbackHipsRoot.
  var FALLBACK_ERROR_LIMIT = 3;
  var FALLBACK_TIMEOUT_MS = 6000;

  // DSO photo overlays mix at 80% over the survey sky, so they don't overpower it.
  var OVERLAY_OPACITY = 0.8;

  /* Plate solutions for the bundled DSO overlay photos, keyed by the names in the section's
     data-overlays map (which supplies each image URL). Each block describes THAT exact
     image (NAXIS1×NAXIS2): if a photo is ever swapped or re-cropped, re-solve and replace
     its block, or its stars land in the wrong place. The engine projects each image onto
     the sky from this, so it stays star-aligned at any pan/zoom. The *-overlay-blend.webp
     files are the same pixels with a feathered alpha edge baked in, so the solve applies.

     M42: astrometry.net job 16205354 (assets/m42-overlay.{jpg,png}), TAN + SIP order-2.
     The rest are UltraCat photos solved locally with astrometry.net 4100-series indexes (TAN):
     M31: UltraCat 108, Michael Page (WO showcase).
     M45: UltraCat 56, Yungshih Lee (WO astrophotography showcase).
     NGC 7000: UltraCat 108, DavesView (WO showcase).
     NGC 2244: UltraCat 108, Rob Pauza (WO showcase). */
  var OVERLAY_WCS = {
    M42: {
      NAXIS: 2, NAXIS1: 1280, NAXIS2: 715, CTYPE3: "RGB",
      WCSAXES: 2, CTYPE1: "RA---TAN", CTYPE2: "DEC--TAN",
      EQUINOX: 2000.0, LONPOLE: 180.0, LATPOLE: 0.0, CUNIT1: "deg", CUNIT2: "deg",
      CRVAL1: 83.8349343445, CRVAL2: -4.58978584527,
      CRPIX1: 237.761312485, CRPIX2: 351.49559021,
      CD1_1: -0.000324155718924, CD1_2: 0.00167585312787,
      CD2_1: -0.00167318012279, CD2_2: -0.000324692110362,
      A_ORDER: 2, A_0_0: 0, A_0_1: 0, A_0_2: -7.53295815582e-7,
      A_1_0: 0, A_1_1: 6.07451251495e-7, A_2_0: 6.39661335308e-7,
      B_ORDER: 2, B_0_0: 0, B_0_1: 0, B_0_2: 1.19452320721e-6,
      B_1_0: 0, B_1_1: 1.90087060601e-7, B_2_0: 1.37587093291e-7,
      AP_ORDER: 2, AP_0_0: -3.23563179078e-5, AP_0_1: -2.00766465459e-7, AP_0_2: 7.53192498508e-7,
      AP_1_0: -2.13373917915e-7, AP_1_1: -6.06590136483e-7, AP_2_0: -6.38567625674e-7,
      BP_ORDER: 2, BP_0_0: -2.02318238286e-5, BP_0_1: 2.08304556972e-7, BP_0_2: -1.19423717418e-6,
      BP_1_0: -2.14589333772e-8, BP_1_1: -1.89554591829e-7, BP_2_0: -1.37339490409e-7,
    },
    M31: {
      NAXIS: 2, NAXIS1: 1824, NAXIS2: 1240, WCSAXES: 2, CTYPE1: "RA---TAN", CTYPE2: "DEC--TAN",
      EQUINOX: 2000.0, LONPOLE: 180.0, LATPOLE: 0.0, CUNIT1: "deg", CUNIT2: "deg",
      CRVAL1: 10.0050815888, CRVAL2: 41.677211169, CRPIX1: 1200.55706063, CRPIX2: 967.048859524,
      CD1_1: 1.13971739737e-05, CD1_2: -0.0013880765844, CD2_1: 0.0013880765844,
      CD2_2: 1.13971739737e-05,
    },
    M45: {
      NAXIS: 2, NAXIS1: 1824, NAXIS2: 1215, WCSAXES: 2, CTYPE1: "RA---TAN", CTYPE2: "DEC--TAN",
      EQUINOX: 2000.0, LONPOLE: 180.0, LATPOLE: 0.0, CUNIT1: "deg", CUNIT2: "deg",
      CRVAL1: 57.394453035, CRVAL2: 23.1879992892, CRPIX1: 1305.51905762, CRPIX2: 677.763813511,
      CD1_1: 0.00111444208332, CD1_2: 0.00248706794393, CD2_1: -0.00248706794393,
      CD2_2: 0.00111444208332,
    },
    "NGC 7000": {
      NAXIS: 2, NAXIS1: 2000, NAXIS2: 1316, WCSAXES: 2, CTYPE1: "RA---TAN", CTYPE2: "DEC--TAN",
      EQUINOX: 2000.0, LONPOLE: 180.0, LATPOLE: 0.0, CUNIT1: "deg", CUNIT2: "deg",
      CRVAL1: 314.528277889, CRVAL2: 43.4900542653, CRPIX1: 850.196811705, CRPIX2: 904.207053278,
      CD1_1: -0.00196604907892, CD1_2: -5.36091401277e-06, CD2_1: 5.36091401277e-06,
      CD2_2: -0.00196604907892,
    },
    "NGC 2244": {
      NAXIS: 2, NAXIS1: 2000, NAXIS2: 1650, WCSAXES: 2, CTYPE1: "RA---TAN", CTYPE2: "DEC--TAN",
      EQUINOX: 2000.0, LONPOLE: 180.0, LATPOLE: 0.0, CUNIT1: "deg", CUNIT2: "deg",
      CRVAL1: 97.9642752711, CRVAL2: 4.7797553299, CRPIX1: 960.960864547, CRPIX2: 633.056764836,
      CD1_1: 0.000807288723135, CD1_2: 0.000586056479684, CD2_1: -0.000586056479684,
      CD2_2: 0.000807288723135,
    },
  };

  function hasValidGeometry(m) {
    return (
      m &&
      Number.isFinite(m.focalLengthMm) &&
      m.focalLengthMm > 0 &&
      Number.isFinite(m.imageCircleMm) &&
      m.imageCircleMm > 0
    );
  }

  var engineLoadPromise = null;

  function globalEngine() {
    return window.WoSkyviewerEngine && window.WoSkyviewerEngine.createSkyViewer
      ? window.WoSkyviewerEngine
      : null;
  }

  function loadGlobalEngine(src) {
    var engine = globalEngine();
    if (engine) return Promise.resolve(engine);
    if (!src) return Promise.reject(new Error("SkyViewer asset URL missing"));
    if (engineLoadPromise) return engineLoadPromise;

    engineLoadPromise = new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = src;
      script.onload = function () {
        var loadedEngine = globalEngine();
        if (loadedEngine) resolve(loadedEngine);
        else {
          engineLoadPromise = null;
          reject(new Error("SkyViewer global did not initialize"));
        }
      };
      script.onerror = function () {
        engineLoadPromise = null;
        reject(new Error("SkyViewer engine asset could not load"));
      };
      document.head.appendChild(script);
    });

    return engineLoadPromise;
  }

  function describeError(err) {
    if (!err) return "";
    if (typeof err === "string") return err;
    return String(err.stack || err.message || err);
  }

  // Solar/planetary bodies fill this fraction of the stage width when zoomed in.
  var TARGET_FILL_RATIO = 0.18;

  var viewerInstanceCounter = 0;
  //將每一個viewer 封包成 class
  class WoSkyviewer {
    constructor(container) {
      this.container = container;

      this.targetViewMode = "native";
      this.canvasEl = container.querySelector("[data-wo-skyviewer-canvas]");
      this.loaderEl = container.querySelector("[data-loader]");
      this.spinnerEl =
        this.loaderEl && this.loaderEl.querySelector("[data-loader-spinner]");
      this.tabListEl = container.querySelector("[data-tab-list]");
      this.responsiveContentEl = container.querySelector(
        "[data-responsive-content]",
      );
      this.svgEl = container.querySelector("[data-coverage-svg]");
      this.circleEl = container.querySelector("[data-image-circle]");
      this.coverageMaskEl = container.querySelector(
        ".wo-skyviewer__coverage-mask",
      );
      this.canvasShellEl = container.querySelector(
        ".wo-skyviewer__canvas-shell",
      );
      this.stageContainerEl = container.querySelector(
        ".wo-skyviewer__stage-container",
      );
      this.buttons = this.tabListEl
        ? Array.from(this.tabListEl.querySelectorAll(".wo-skyviewer__tab-button"))
        : [];
      this.sensorRects = Array.from(
        this.svgEl.querySelectorAll("[data-sensor]"),
      );
      this.sensorLabels = Array.from(
        this.svgEl.querySelectorAll("[data-label]"),
      );

      this.sectionId =
        container.dataset.sectionId || String(++viewerInstanceCounter);

      // Classic-script engine asset; avoids ESM asset imports in Shopify Theme Editor.
      this.globalSrc = container.dataset.woSkyviewerGlobalSrc || "";
      // Optional HiPS tile root override (e.g. a closer mirror / CDN edge cache); empty = CDS default.
      this.hipsRoot = container.dataset.woSkyviewerHipsRoot || "";
      // Bundled DSO photos laid over the survey sky ({name: url}), star-aligned via OVERLAY_WCS.
      this.overlaySrcs = {};
      try {
        this.overlaySrcs = JSON.parse(container.dataset.overlays || "{}") || {};
      } catch (e) {}
      this.animationMode = container.dataset.animationMode || "none";
      // True while a tab-switch FOV tween (morph) is in flight. The engine's "render" event
      // fires syncOverlayScale() on every frame regardless of what triggered the render, which
      // would otherwise race buildOverlayTween's own per-frame writes and recompute frame
      // visibility against a mid-tween FOV/model pairing — flickering APS-C/Full-Frame in and
      // out right as the switch lands. See syncOverlayScale().
      this._isFovTweening = false;
      // Model the morph tween is committing to when it lands (set at tween start, cleared on
      // commit). Lets a mouse interruption finish the pending model swap instead of leaving
      // activeIndex/activeModel mismatched.
      this._pendingNextModel = null;
      // Planet scale-reference picker: bodies sized by true relative diameter, shown at the FOV
      // center as a plain SVG <image> (viewer-independent). Default = -1 (None). planet_render_mode
      // (schema) selects the href source: "svg" (file url) | "inline" (base64 data uri).
      this.planets = this.readPlanets();
      this.planetIndex = -1;
      this.planetRenderMode = container.dataset.planetRenderMode || "svg";
      // "cursor" (default): engine zooms toward mouse pos. "center": always zooms from screen center (no drift).
      this.zoomMode = container.dataset.zoomMode || "cursor";
      // FOV fly-in animation duration for solar/DSO picks, in ms (from schema range 0-8s).
      this.fovAnimDuration = Math.round((parseFloat(container.dataset.fovAnimDuration) || 2.5) * 1000);
      // Transition animation duration for switching telescope tabs, in ms (from schema range 0-8s).
      this.switchAnimDuration = Math.round((parseFloat(container.dataset.switchAnimDuration) || 1.0) * 1000);
      container.style.setProperty("--switch-duration", (this.switchAnimDuration / 1000) + "s");
      this.planetRulerEl = container.querySelector("[data-planet-ruler]"); // svg + inline modes
      // Category pill selection variables removed.

      // Scale-reference suggestions drop below the search input (Google-style typeahead).
      this.suggestEl = container.querySelector("[data-suggest]");
      this.suggestCategory = "dso"; // pill filter: "solar" | "dso"
      this.suggestActive = -1; // arrow-key highlighted option (index into suggestOptionEls)

      // Search box (resolves any object via Sesame; recenters with FOV locked).
      this.searchFormEl = container.querySelector("[data-wo-skyviewer-search]");
      this.searchInputEl = container.querySelector(
        "[data-wo-skyviewer-search-input]",
      );
      this.searchClearEl = container.querySelector(
        "[data-wo-skyviewer-search-clear]",
      );
      this.searchToggleEl = container.querySelector(
        "[data-wo-skyviewer-search-toggle]",
      );

      this.startLoaderSpinner();
      this.models = this.readModels();
      if (!this.models.length) {
        this.showLoaderMessage("Select a telescope");
        return;
      }

      this.validModelIndexes = this.models.reduce(function (indexes, m, i) {
        if (hasValidGeometry(m)) indexes.push(i);
        return indexes;
      }, []);
      if (!this.validModelIndexes.length) {
        this.showLoaderMessage("Add focal length and image circle metafields");
        return;
      }

      // Margin grows with the merchant's feather so the ring always hosts the fade, but
      // low softness keeps the disc large. --mask-feather is set in Liquid regardless of
      // enable_mask, so the geometry is the same whether the crop is shown or not.
      var feather =
        parseFloat(
          getComputedStyle(container).getPropertyValue("--mask-feather"),
        ) || 0;
      var f = feather / 100;
      // Calculate the exact minimum margin required to fit the feather fade
      // without hitting the square frame bounds, completely absorbing the feather
      // instead of adding it on top of the base margin.
      var margin = Math.max(STAGE_MARGIN_BASE, f < 1 ? (f / (1 - f)) : 0);
      var maxCircle = Math.max.apply(
        null,
        this.models.filter(hasValidGeometry).map(function (m) {
          return m.imageCircleMm;
        }),
      );
      this.stageMm =
        Math.max(maxCircle, maxSensorSpanMm(SKY_CFG.sensors, maxCircle)) * (1 + margin);
      this.activeIndex =
        this.validModelIndexes.indexOf(SKY_CFG.defaultIndex) >= 0
          ? SKY_CFG.defaultIndex
          : this.validModelIndexes[0];
      this.activeModel = this.models[this.activeIndex];

      this.canvasId =
        "wo-skyviewer-canvas-" + this.sectionId + "-" + ++viewerInstanceCounter;
      this.canvasEl.id = this.canvasId;
      if (this.stageContainerEl) {
        this.stageContainerEl.id = "panel-" + this.canvasId;
        this.stageContainerEl.setAttribute("role", "tabpanel");
      }

      this._activeFrame = null;
      this._frameTapMode = false;
      this._framePointerStartPos = null;
      this._framePointerMoved = false;

      this.init();
    }

    isDisposed() {
      return this.disposed || this.container.isConnected === false;
    }

    listen(target, name, callback, options) {
      var self = this;
      var guarded = function (event) {
        if (!self.isDisposed()) callback.call(this, event);
      };
      target.addEventListener(name, guarded, options);
      var cleanup = function () {
        target.removeEventListener(name, guarded, options);
        var index = self._cleanups.indexOf(cleanup);
        if (index >= 0) self._cleanups.splice(index, 1);
      };
      (this._cleanups || (this._cleanups = [])).push(cleanup);
      return cleanup;
    }

    listenSuggest(target, name, callback) {
      this._suggestCleanups.push(this.listen(target, name, callback));
    }

    schedule(callback, delay, kind) {
      if (this.isDisposed()) return;
      var self = this;
      var pending = this._scheduled || (this._scheduled = new Map());
      var cancel = kind === "frame" ? "cancelAnimationFrame" : kind === "idle" ? "cancelIdleCallback" : "clearTimeout";
      var run = function (value) {
        pending.delete(run);
        if (!self.isDisposed()) callback(value);
      };
      var id = kind === "frame" ? window.requestAnimationFrame(run) : kind === "idle" ? window.requestIdleCallback(run) : window.setTimeout(run, delay);
      pending.set(run, { id: id, kind: kind, cancel: function () { window[cancel](id); } });
      return id;
    }

    cancelScheduled(id, kind) {
      this._scheduled?.forEach(function (item, key, pending) {
        if (item.id === id && item.kind === kind) {
          item.cancel();
          pending.delete(key);
        }
      });
    }

    frame(callback) {
      return this.schedule(callback, 0, "frame");
    }

    dispose() {
      if (this.disposed) return;
      this.disposed = true;
      this._bootObserver?.disconnect();
      this._layoutObserver?.disconnect();
      this._simbadAbort?.abort();
      this._scheduled?.forEach(function (item) { item.cancel(); });
      this._scheduled?.clear();
      var cleanups = this._cleanups || [];
      this._cleanups = [];
      cleanups.forEach(function (cleanup) { cleanup(); });
      this._suggestCleanups = [];
      this.stopLoaderSpinner();
      if (this._fovAnimId) this.cancelScheduled(this._fovAnimId, "frame");
      this._pendingNextModel = null;
      this._isFovTweening = false;
      this.viewer?.destroy();
      this.viewer = null;
      delete this.container.dataset.initialized;
    }

    readModels() {
      var el = this.container.querySelector("[data-wo-skyviewer-models]");
      if (!el) return [];
      try {
        var parsed = JSON.parse(el.textContent);
        if (!Array.isArray(parsed)) return [];
        parsed.forEach(function (m) {
          m.focalLengthMm = Number(m.focalLengthMm) || 0;
          m.imageCircleMm = Number(m.imageCircleMm) || 0;
          m.formats = supportedFormats(m.imageCircleMm, SKY_CFG.sensors);
        });
        return parsed;
      } catch (e) {
        return [];
      }
    }

    /* Scale-reference list from Liquid: [{name, category, src, diameterKm? , spanDeg?}].
       Solar bodies derive span° from diameterKm (true relative size); DSOs give an explicit
       spanDeg (their on-sky size). category drives the two-level menu grouping. */
    readPlanets() {
      var el = this.container.querySelector("[data-planets]");
      if (!el) return [];
      // All planets now use explicit spanDeg in Liquid JSON; diameterKm path removed.
      var uris = this.readPlanetDataUris(); // name → base64 data URI (for "inline" render mode)
      try {
        var parsed = JSON.parse(el.textContent);
        if (!Array.isArray(parsed)) return [];
        return parsed.map(function (p) {
          var span = p.spanDeg || 0;
          return {
            name: p.name,
            displayName: p.displayName || "",
            category: p.category || "solar",
            src: p.src,
            span: span,
            data: uris[p.name] || null,
          };
        });
      } catch (e) {
        return [];
      }
    }

    readPlanetDataUris() {
      var el = this.container.querySelector("[data-planet-datauris]");
      if (!el) return {};
      try {
        return JSON.parse(el.textContent) || {};
      } catch (e) {
        return {};
      }
    }

    init() {
      var self = this;
      this.setOverlayViewBox(this.stageMm);
      this.updateTabStates();
      this.updateResponsiveContent(this.activeModel);
      this.updateOverlay(this.activeModel);

      this.buttons.forEach(function (b) {
        self.listen(b, "click", function () {
          self.setActiveIndex(Number(b.dataset.index));
        });
        self.listen(b, "keydown", function (e) {
          self.onTabKeydown(e);
        });
        // Fill each tab's accordion spec from its model (formats derived from image circle).
        var spec = b.querySelector("[data-spec]");
        var model = self.models[Number(b.dataset.index)];
        if (model && !hasValidGeometry(model)) {
          b.disabled = true;
          b.setAttribute("aria-disabled", "true");
          b.title = "Add focal length and image circle metafields";
        }
        if (spec && model)
          spec.innerHTML = hasValidGeometry(model)
            ? self.specMarkup(model)
            : "<p>Add focal length and image circle metafields.</p>";
      });

      this.initSearch();
      this.initSuggest();
      this.initSearchToggle();

      if (this.canvasEl) {
        this.listen(this.canvasEl, "contextmenu", function (e) {
          e.preventDefault();
        });
        this.listen(this.canvasEl, "selectstart", function (e) {
          e.preventDefault();
        });
        this.listen(this.canvasEl,
          "pointerdown",
          function () {
            self.interruptFovAnim();
            self.closeSearch();
          },
          { passive: true },
        );
        this.listen(this.canvasEl,
          "wheel",
          function (e) {
            if (!self.viewer) return;
            self.interruptFovAnim();
            self.closeSearch();
            var maxFov = lockedFov(self.activeModel, self.stageMm);
            var curFov = self.viewer.getFovDeg();
            var factor = Math.exp(e.deltaY * 1e-3);
            var resultFov = curFov * factor;

            if (resultFov > maxFov) {
              // Always block zoom-out past the limit regardless of mode —
              // the engine’s cursor-pivot zoomBy would shift the center if we let it run.
              e.preventDefault();
              e.stopPropagation();
              if (curFov < maxFov) self.viewer.setFovDeg(maxFov);
              self.trackWheel(curFov, true);
              return;
            }

            if (self.zoomMode === "center") {
              // Center mode: intercept and zoom via setFovDeg — FOV changes, center never moves.
              e.preventDefault();
              e.stopPropagation();
              self.viewer.setFovDeg(Math.max(0.001, resultFov));
              self.trackWheel(curFov, true);
            } else {
              self.trackWheel(curFov, false);
            }
            // Cursor mode: fall through to engine’s cursor-pivot zoomBy (normal star-map UX)
          },
          { capture: true, passive: false },
        );
      }

      if (this.svgEl) {
        this.listen(this.svgEl, "contextmenu", function (e) {
          e.preventDefault();
        });
        this.listen(this.svgEl, "selectstart", function (e) {
          e.preventDefault();
        });
      }

      this.initFrameOverlay();

      this.bootWhenVisible();
    }

    /* The engine boots once the viewer nears the viewport. Tabs/overlay/spec already render
       above, so below-fold viewers cost zero work until scrolled to. */
    bootWhenVisible() {
      var self = this;
      // no IntersectionObserver → boot immediately. Not worth a polyfill.
      if (!("IntersectionObserver" in window)) return this.startViewer();
      var io = this._bootObserver = new IntersectionObserver(
        function (entries) {
          if (self.isDisposed() || !entries[0].isIntersecting) return;
          io.disconnect();
          self.startViewer();
        },
        { rootMargin: "600px" },
      );
      io.observe(this.container);
    }

    /* Load the local engine bundle and mount an interactive (pan/zoom) viewer into the canvas. */
    loadEngine() {
      if (this.globalSrc) return loadGlobalEngine(this.globalSrc);
      var engine = globalEngine();
      if (engine) return Promise.resolve(engine);
      return Promise.reject(new Error("SkyViewer asset URL missing"));
    }

    startViewer() {
      if (this.isDisposed() || this._viewerStarted) return;
      this._viewerStarted = true;
      var self = this;
      var startedAt = performance.now();
      var center = parseTarget(SKY_CFG.target);
      this.viewCenter = center;

      this.loadEngine()
        .then(function (lib) {
          if (self.isDisposed()) return;
          self.lib = lib;
          self._startedAt = startedAt;
          self.mountViewer(self.hipsRoot || undefined, {
            center: center,
            fovDeg: lockedFov(self.activeModel, self.stageMm),
          });
          self.syncOverlayScale();
          self.preloadPlanetImages(); // warm the cache so the first pick renders without a download
          self.initTrackingGestures();
        })
        .catch(function (err) {
          if (self.isDisposed()) return;
          self.failLoader(self.failureMessage(err));
          self.emitInteraction("viewer_error", { reason: "initialization" });
        });

      // Fall back if the sky never paints (e.g. tile CORS/network). Editor → friendly notice;
      // live store → fail message.
      self.schedule(function () {
        if (self.container.getAttribute("aria-busy") !== "true") return;
        if (window.Shopify && window.Shopify.designMode)
          self.showEditorNotice();
        else {
          self.failLoader(self.failureMessage(self.lastViewerError));
          self.emitInteraction("viewer_error", { reason: "timeout" });
        }
      }, 12000);
    }

    /* Create the engine viewer on a HiPS root (undefined = CDS default). If the sky hasn't
       painted after FALLBACK_ERROR_LIMIT tile errors or FALLBACK_TIMEOUT_MS, rebuild once on
       SKY_CFG.fallbackHipsRoot at the current view. The engine owns its <canvas> inside
       canvasEl, so destroy + recreate leaves the theme DOM and gesture listeners intact. */
    mountViewer(rootUrl, view) {
      var self = this;
      var viewer = (this.viewer = this.lib.createSkyViewer(this.canvasEl, {
        survey: SKY_CFG.survey,
        hipsRootUrl: rootUrl,
        center: view.center,
        fovDeg: view.fovDeg,
        projection: "SIN",
        interactive: true, // free pan/zoom; the SVG frames stay a fixed centered reticle
      }));
      var isCurrent = function () {
        return !self.isDisposed() && self.viewer === viewer;
      };
      var painted = false;
      var errorCount = 0;
      var canFallBack =
        !this._usingFallbackRoot && rootUrl !== SKY_CFG.fallbackHipsRoot;
      var fallBack = function () {
        if (!isCurrent() || painted || !canFallBack) return;
        canFallBack = false;
        var current = { center: viewer.getCenter(), fovDeg: viewer.getFovDeg() };
        viewer.destroy();
        self._usingFallbackRoot = true;
        self.mountViewer(SKY_CFG.fallbackHipsRoot, current);
      };

      viewer.setMaxFovLimit(lockedFov(this.activeModel, this.stageMm));
      this.mountOverlays(viewer);
      viewer.on("error", function (event) {
        if (!isCurrent()) return;
        self.lastViewerError =
          (event && event.error) || (event && event.message) || event;
        self.emitInteraction("viewer_error", { reason: "asset" });
        if (++errorCount >= FALLBACK_ERROR_LIMIT) fallBack();
      });
      // Hide the loader as soon as sky pixels paint — the low-res allsky backdrop (baseReady)
      // or the first real tile, whichever lands first.
      var off = viewer.on("render", function (e) {
        if (!isCurrent() || !e || (!e.baseReady && e.loadedTileCount <= 0)) return;
        off();
        painted = true;
        self.stopLoaderSpinner();
        if (self.loaderEl) self.loaderEl.classList.add("is-hidden");
        self.container.setAttribute("aria-busy", "false");
        self.emitInteraction("viewer_ready", {
          loadDurationMs: Math.round(performance.now() - self._startedAt),
        });
      });
      // Keep the SVG frames/circle/labels/ruler + mask sized to the live sky FOV as the
      // user zooms (they stay centered, so pan needs no work).
      viewer.on("render", function () {
        if (isCurrent()) self.syncOverlayScale();
      });
      if (canFallBack) this.schedule(fallBack, FALLBACK_TIMEOUT_MS);
    }

    // Add every DSO overlay that has both an image and a plate solve. Edge fades are baked
    // into each file's alpha (*-overlay-blend.webp).
    mountOverlays(viewer) {
      var srcs = this.overlaySrcs;
      Object.keys(srcs).forEach(function (name) {
        if (!srcs[name] || !OVERLAY_WCS[name]) return;
        viewer.addWcsImageOverlay({
          url: srcs[name],
          wcs: OVERLAY_WCS[name],
          opacity: OVERLAY_OPACITY,
          zIndex: 1,
        });
      });
    }

    // Switching telescope resets the sky to that model's FOV as a starting frame; the user
    // can still pan/zoom freely from there (interactive).
    setFov(fov) {
      if (this.viewer) this.viewer.setFovDeg(fov);
    }

    /* Search a celestial object by name. Resolve to coordinates via the engine's Sesame
       resolver, then recenter with setCenter — the FOV lock holds (we never change fovDeg here).
       On success reset the planet scale-ref (it's anchored to the field center, so it'd drift
       off). On failure flag the input. */
    search(query, source) {
      this.trackingTarget = null;
      if (!this.viewer || !this.lib || !this.lib.resolveName) return;
      query = String(query || "").trim();
      if (!query) return;
      var self = this;
      source = source || "typed";
      if (source === "catalog") self.emitInteraction("search_submitted", { source: source });
      this.clearSearchError();

      var DSO_COORDS = {
        "m42": { ra: 83.82208, dec: -5.39111 },
        "orion nebula": { ra: 83.82208, dec: -5.39111 },
        "m31": { ra: 10.68471, dec: 41.26875 },
        "andromeda galaxy": { ra: 10.68471, dec: 41.26875 },
        "m45": { ra: 56.75, dec: 24.1167 },
        "pleiades": { ra: 56.75, dec: 24.1167 },
        "m33": { ra: 23.4621, dec: 30.6602 },
        "triangulum galaxy": { ra: 23.4621, dec: 30.6602 },
        "m51": { ra: 202.4696, dec: 47.1953 },
        "whirlpool galaxy": { ra: 202.4696, dec: 47.1953 },
        "m8": { ra: 270.9167, dec: -24.3833 },
        "lagoon nebula": { ra: 270.9167, dec: -24.3833 },
        "m16": { ra: 274.7, dec: -13.79 },
        "eagle nebula": { ra: 274.7, dec: -13.79 },
        "ngc 7000": { ra: 314.75, dec: 44.3333 },
        "north america nebula": { ra: 314.75, dec: 44.3333 },
        "ngc 2244": { ra: 98.0583, dec: 4.8625 },
        "rosette nebula": { ra: 98.0583, dec: 4.8625 },
        "m101": { ra: 210.8024, dec: 54.3488 },
        "pinwheel galaxy": { ra: 210.8024, dec: 54.3488 }
      };

      var key = query.toLowerCase().replace(/\(.*?\)/g, "").trim();
      if (DSO_COORDS[key]) {
        var coord = DSO_COORDS[key];
        self.viewCenter = coord;
        self.viewer.setCenter(coord);
        self.setScaleRef(-1);
        self.emitInteraction("search_result", { source: source, outcome: "success" });
        return;
      }

      this.lib
        .resolveName(query)
        .then(function (coord) {
          if (self.isDisposed()) return;
          if (!coord) {
            self.showSearchError();
            self.emitInteraction("search_result", { source: source, outcome: "no_result" });
            return;
          }
          self.viewCenter = coord;
          self.viewer.setCenter(coord);
          self.setScaleRef(-1); // hide the ruler on navigate
          self.emitInteraction("search_result", { source: source, outcome: "success" });
        })
        .catch(function () {
          if (self.isDisposed()) return;
          self.showSearchError();
          self.emitInteraction("search_result", { source: source, outcome: "error" });
        });
    }

    showSearchError() {
      if (this.searchFormEl) this.searchFormEl.classList.add("is-error");
    }

    clearSearchError() {
      if (this.searchFormEl) this.searchFormEl.classList.remove("is-error");
    }

    /* Enter on the search box submits → search(). Editing clears any error state and toggles
       the clear (✕) button. The ✕ empties the field and refocuses it. */
    initSearch() {
      var self = this;
      if (!this.searchFormEl) return;
      this.listen(this.searchFormEl, "submit", function (e) {
        e.preventDefault();
        var q = self.searchInputEl ? self.searchInputEl.value : "";
        var idx = self.matchedPlanetIndex(q);
        var isSolarBody = self.planets.some(function (p) {
          return (
            p.category === "solar" && p.name.toLowerCase() === q.toLowerCase()
          );
        });
        if (idx >= 0) {
          // exact list match → scale ref (solar) or navigate (dso)
          self.applyPick(idx, "typed");
        } else if (!isSolarBody) {
          self.targetViewMode = "native";

          self.search(q); // DSO or other → Sesame can reach the whole sky
          self.closeSuggest();
          self.updateFrameVisibility();
        }
        // else Solar System + no match → blocked: leave the panel open showing "No match".
      });

      if (this.searchClearEl) {
        this.listen(this.searchClearEl, "click", function (e) {
          e.preventDefault();
          self.trackingTarget = null;
          if (self.searchInputEl) {
            self.searchInputEl.value = "";
            self.searchInputEl.focus();
          }
          self.setScaleRef(-1); // clearing the box also cancels the scale-ref overlay
          self.clearSearchError(); // keep the current category filter so the user can pick again
          self.updateSearchClear();
          
          self._isTyping = false;
          self.openSuggest(); // open the suggest panel to show defaults
        });
      }
      this.updateSearchClear();

      // The tab list is vertically centered, so its top edge can't be derived in CSS — measure
      // it and feed --wo-skyviewer-search-top. Its height shifts on web-font load, accordion
      // expand, and tab switches (not just window resize), so a ResizeObserver on the list +
      // stage re-measures on ANY geometry change; window.resize is the fallback where missing.
      var raf;
      var schedule = function () {
        if (self.isDisposed()) return;
        if (raf) self.cancelScheduled(raf, "frame");
        raf = self.frame(function () {
          self.repositionPlanet();
        });
      };
      schedule();
      if ("ResizeObserver" in window) {
        var ro = this._layoutObserver = new ResizeObserver(schedule);
        if (this.tabListEl) ro.observe(this.tabListEl);
        if (this.stageContainerEl) ro.observe(this.stageContainerEl);
      }
      this.listen(window, "resize", schedule);
      if (document.fonts && document.fonts.ready)
        document.fonts.ready.then(schedule);
    }

    /* Show the ✕ only when the field has text. */
    updateSearchClear() {
      if (!this.searchClearEl) return;
      var hasText = !!(this.searchInputEl && this.searchInputEl.value.trim());
      this.searchClearEl.hidden = !(hasText || this.planetIndex >= 0);
    }

    /* Warm the browser cache with the solar-body PNGs during IDLE time so the first pick paints
       instantly. Sequential + requestIdleCallback-gated so it never competes with the initial sky
       tile load. */
    preloadPlanetImages() {
      var self = this;
      var srcs = this.planets
        .filter(function (p) {
          return p.category === "solar";
        })
        .map(function (p) {
          return p.src;
        });
      var idle = function (fn) {
        return window.requestIdleCallback ? self.schedule(fn, 0, "idle") : self.schedule(fn, 200);
      };
      var i = 0;
      var next = function () {
        if (self.isDisposed() || i >= srcs.length) return;
        var img = new Image();
        (self._cleanups || (self._cleanups = [])).push(function () { img.onload = img.onerror = null; });
        img.onload = img.onerror = function () {
          if (self.isDisposed()) return;
          i++;
          idle(next);
        };
        img.src = srcs[i];
      };
      idle(next);
    }

    // On-sky angular span of the current body, in mm (1 unit = 1mm across stageMm).
    planetSpanMm() {
      return (
        (this.planets[this.planetIndex].span * this.stageMm) /
        lockedFov(this.activeModel, this.stageMm)
      );
    }

    /* ─── Render mode: "svg" (SVG <image> in the overlay) ─── instant, scales with the viewBox. */
    sizePlanetRuler() {
      if (!this.planetRulerEl || this.planetIndex < 0) return;
      this.setPlanetRulerMm(this.planetSpanMm());
    }

    setPlanetRulerMm(mm) {
      var el = this.planetRulerEl;
      if (!el) return;
      el.setAttribute("x", -mm / 2);
      el.setAttribute("y", -mm / 2);
      el.setAttribute("width", mm);
      el.setAttribute("height", mm);
    }
    // svg + inline share the SVG <image>; only the href source differs (file URL vs base64 data URI).
    showPlanetSvg(index, href) {
      var el = this.planetRulerEl;
      if (!el) return;
      href = href || this.planets[index].src;
      if (!href) return; // DSOs with no image — skip ruler display
      if (el.getAttribute("href") !== href) el.setAttribute("href", href);
      this.sizePlanetRuler();
      el.style.display = "inline";
    }

    /* ─── Render mode: "inline" ─── svg backend, but the image is a base64 data URI baked into the
       page (data-planet-datauris) → zero network request at pick time. Falls back to the file URL
       if a body has no inlined data. */
    showPlanetInline(index) {
      var p = this.planets[index];
      this.showPlanetSvg(index, p.data || p.src);
    }

    /* Hide the ruler — used on pick-clear and before each show. */
    hidePlanet() {
      if (this.planetRulerEl) this.planetRulerEl.style.display = "none";
    }

    repositionPlanet() {
      if (this.planetIndex < 0) return;
      if (this._isFovTweening) return;
      this.sizePlanetRuler();
    }

    /* Show the picked body as a size ruler at the FOV center via the schema-selected backend
       (planet_render_mode: "svg" | "inline"). -1 = hide. */
    setScaleRef(index) {
      if (index >= this.planets.length) return;
      this.planetIndex = index;
      this.hidePlanet();
      if (index >= 0) {
        if (this.planetRenderMode === "inline") this.showPlanetInline(index);
        else this.showPlanetSvg(index);
      }
      this.updateScaleRefUI();
    }

    /* Clear (✕) shows when there's text OR a scale ref is applied; an open suggestion panel
       re-renders to mark the active option. */
    updateScaleRefUI() {
      this.updateSearchClear();
      if (this.suggestOpen) this.renderSuggest();
    }

    /* Reveal showEl, fade it in while fading hideEl out, then hide hideEl once the transition
       lands so it drops out of layout/a11y/tab order again. Shared by the toggle click and by
       closeSearch() (outside click / map interaction). */
    crossfadeSearchToggle(showEl, hideEl) {
      var self = this;
      showEl.hidden = false;
      showEl.classList.add("is-hiding");
      void showEl.offsetWidth; // force layout so the browser registers the pre-transition state
      showEl.classList.remove("is-hiding");
      hideEl.classList.add("is-hiding");
      self.schedule(function () {
        hideEl.hidden = true;
        hideEl.classList.remove("is-hiding");
      }, 200); // must match the SCSS transition duration
    }

    /* Collapse the search box back to the icon — used for outside clicks and for panning/
       zooming the sky map, so an idle open search box doesn't sit there covering the view. */
    closeSearch() {
      if (!this.searchToggleEl || !this.searchFormEl) return;
      if (this.searchFormEl.hidden) return;
      this.searchToggleEl.setAttribute("aria-expanded", "false");
      this.crossfadeSearchToggle(this.searchToggleEl, this.searchFormEl);
      if (this.suggestOpen) this.closeSuggest();

      // Clear search query and suggestions state on close
      if (this.searchInputEl) this.searchInputEl.value = "";
      if (this._simbadTimer) this.cancelScheduled(this._simbadTimer);
      this._simbadLoading = false;
      this._simbadItems = undefined;
    }

    /* Toggles .wo-skyviewer__search open/closed. Icon and form share one screen position (see
       SCSS), so opening/closing crossfades between them instead of just toggling [hidden]
       instantly. Closes on outside click and on map pan/zoom (interruptFovAnim's listeners
       call closeSearch() too) — an open search box otherwise never goes away on its own. */
    initSearchToggle() {
      var self = this;
      if (!this.searchToggleEl || !this.searchFormEl) return;
      this.listen(this.searchToggleEl, "click", function () {
        var opening = self.searchFormEl.hidden;
        self.searchToggleEl.setAttribute("aria-expanded", String(opening));
        if (opening) {
          self.crossfadeSearchToggle(self.searchFormEl, self.searchToggleEl);
          if (self.searchInputEl) self.searchInputEl.focus();
        } else {
          self.crossfadeSearchToggle(self.searchToggleEl, self.searchFormEl);
        }
      });
      this.listen(document, "click", function (e) {
        if (
          !self.searchFormEl.hidden &&
          !self.searchFormEl.contains(e.target) &&
          !self.searchToggleEl.contains(e.target)
        ) {
          self.closeSearch();
        }
      });
    }

    /* Scale-reference typeahead: focusing the search input drops a panel of true-scale bodies,
       filtered by the pill's category + the typed text. Picking one applies its overlay
       (setScaleRef). Enter with no highlighted option falls through to the form's Sesame search. */
    initSuggest() {
      var self = this;
      if (!this.suggestEl || !this.searchInputEl) return;
      this.suggestEl.id = "wo-skyviewer-suggest-" + this.canvasId;
      this.searchInputEl.setAttribute("role", "combobox");
      this.searchInputEl.setAttribute("aria-controls", this.suggestEl.id);
      this.searchInputEl.setAttribute("aria-expanded", "false");
      this.searchInputEl.setAttribute("aria-autocomplete", "list");

      this.listen(this.searchInputEl, "focus", function () {
        if (!self.searchInputEl.value.trim()) {
          self._isTyping = false;
          if (!self.suggestOpen) self.openSuggest();
        } else {
          self.schedule(function () {
            self.searchInputEl.select();
            if (!self.suggestOpen) self.openSuggest();
          }, 0);
        }
      });
      // focus doesn't re-fire on an already-focused box, so a click reopens after backspace-clear.
      this.listen(this.searchInputEl, "click", function () {
        if (!self.searchInputEl.value.trim()) {
          self._isTyping = false;
        }
        if (!self.suggestOpen) self.openSuggest();
      });
      this.listen(this.searchInputEl, "input", function () {
        var val = self.searchInputEl.value.trim();
        self.clearSearchError();
        self.updateSearchClear();

        if (!val) {
          self.trackingTarget = null;
          // Cancel any pending SIMBAD fetch and reset state
          if (self._simbadTimer) self.cancelScheduled(self._simbadTimer);
          self._simbadLoading = false;
          self._simbadItems = undefined;
          self._isTyping = false; // Reset typing mode to show preconfigured defaults
          
          if (self.planetIndex >= 0) self.setScaleRef(-1);
          self.targetViewMode = "native";
          self.updateFrameVisibility();

          self.suggestOpen ? self.renderSuggest() : self.openSuggest();
          return;
        }
        self._isTyping = true;
        
        var matchIdx = self.matchedPlanetIndex(val);
        if (matchIdx < 0) {
          self.trackingTarget = null;
          self.targetViewMode = "native";
          self.updateFrameVisibility();
        }

        // Trigger live SIMBAD autocomplete when in DSO mode
        if (self.suggestCategory === "dso") self._startSimbadFetch(val);
        self.suggestOpen ? self.renderSuggest() : self.openSuggest();
      });
      this.listen(this.searchInputEl, "keydown", function (e) {
        self.onSuggestKey(e);
      });
    }

    openSuggest() {
      if (!this.suggestEl || this.suggestOpen) return;
      this.suggestOpen = true;
      this.suggestEl.hidden = false;
      this.searchInputEl.setAttribute("aria-expanded", "true");
      this.renderSuggest();
      this.hideFrameOverlay();
    }

    closeSuggest() {
      if (!this.suggestEl) return;
      this.suggestOpen = false;
      this.suggestEl.hidden = true;
      this.suggestActive = -1;
      this.searchInputEl.setAttribute("aria-expanded", "false");
    }

    /* Queue a SIMBAD TAP autocomplete fetch (debounced 350 ms).
       Normalises catalog prefixes so "NGC1966" → "NGC 1966" before querying.
       State lives on the instance: _simbadLoading (bool), _simbadItems (array|undefined). */
    _startSimbadFetch(rawQ) {
      var self = this;
      this._simbadAbort?.abort();
      if (this._simbadTimer) this.cancelScheduled(this._simbadTimer);

      var qTrim = rawQ.trim();
      if (!qTrim) return;

      var norm = "";
      var whereClause = "";
      // Check if the query has a catalog prefix followed by number format, e.g. "NGC1966" or "NGC 1966"
      var isCatalogPattern = /[A-Z]+\s*\d+/i.test(qTrim);

      if (isCatalogPattern) {
        norm = qTrim
          .replace(/\s+/g, "")
          .toUpperCase()
          .replace(/^([A-Z]+)(\d+)/, "$1%$2");
        whereClause = "i.id LIKE '" + norm.replace(/'/g, "''") + "%'";
      } else {
        // Common name query (letters only or space separated words)
        // Generate three variations to bypass ADQL's lack of LOWER/UPPER string functions
        var rawUpper = qTrim.toUpperCase().replace(/\s+/g, "%");
        var rawLower = qTrim.toLowerCase().replace(/\s+/g, "%");
        var rawTitle = qTrim.toLowerCase().replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }).replace(/\s+/g, "%");

        var u = rawUpper.replace(/'/g, "''");
        var l = rawLower.replace(/'/g, "''");
        var t = rawTitle.replace(/'/g, "''");

        whereClause = "(" +
          "i.id LIKE '" + t + "%' OR i.id LIKE '" + u + "%' OR i.id LIKE '" + l + "%' OR " +
          "(i.id LIKE 'NAME %' AND (i.id LIKE '%" + t + "%' OR i.id LIKE '%" + u + "%' OR i.id LIKE '%" + l + "%'))" +
          ")";
      }

      this._simbadLoading = true; // renderSuggest shows spinner immediately on next paint
      this._simbadQ = rawQ;

      this._simbadTimer = self.schedule(function () {
        var adql =
          "SELECT TOP 100 b.oid, i.id, b.main_id, i2.id as alias_name, b.nbref " +
          "FROM basic b " +
          "JOIN ident i ON b.oid = i.oidref " +
          "LEFT OUTER JOIN ident i2 ON b.oid = i2.oidref AND i2.id LIKE 'NAME %' " +
          "WHERE " + whereClause + " ORDER BY nbref DESC";
        var controller = self._simbadAbort = new AbortController();
        fetch(
          "https://simbad.cds.unistra.fr/simbad/sim-tap/sync" +
            "?REQUEST=doQuery&LANG=ADQL&FORMAT=json&QUERY=" +
            encodeURIComponent(adql),
          { signal: controller.signal }
        )
          .then(function (r) {
            return r.ok ? r.json() : Promise.reject(r.status);
          })
          .then(function (data) {
            if (self.isDisposed() || self._simbadQ !== rawQ) return; // stale — a newer query is in flight
            self._simbadLoading = false;

            var oidMap = {};
            (data.data || []).forEach(function (row) {
              var oid = row[0];
              var id = (row[1] || "").trim().replace(/\s+/g, " ");
              if (/^NAME\s+/i.test(id)) {
                id = id.replace(/^NAME\s+/i, "");
              }

              var mainIdRaw = (row[2] || "").trim().replace(/\s+/g, " ");
              var mainId = mainIdRaw;
              var isMainName = /^NAME\s+/i.test(mainIdRaw);
              if (isMainName) {
                mainId = mainId.replace(/^NAME\s+/i, "");
              }

              var aliasName = (row[3] || "").trim().replace(/\s+/g, " ");
              var nbref = Number(row[4]) || 0;

              var cleanAlias = aliasName;
              if (/^NAME\s+/i.test(cleanAlias)) {
                cleanAlias = cleanAlias.replace(/^NAME\s+/i, "");
              }

              if (!oidMap[oid]) {
                oidMap[oid] = {
                  id: id,
                  mainId: mainId,
                  isMainName: isMainName,
                  nbref: nbref,
                  commonName: cleanAlias || ""
                };
              } else {
                // Deduplicate and keep the longest common name alias (e.g. "Small Magellanic Cloud" over "SMC")
                if (cleanAlias && cleanAlias.length > oidMap[oid].commonName.length) {
                  oidMap[oid].commonName = cleanAlias;
                }
              }
            });

            var oids = Object.keys(oidMap);
            var results = oids.map(function (oid) { return oidMap[oid]; });
            results.sort(function (a, b) { return b.nbref - a.nbref; });

            self._simbadItems = results.slice(0, 20);
            if (self.suggestOpen) self.renderSuggest();
          })
          .catch(function () {
            if (self.isDisposed() || self._simbadQ !== rawQ) return;
            self._simbadLoading = false;
            self._simbadItems = []; // empty — treat as no results
            if (self.suggestOpen) self.renderSuggest();
          });
      }, 350);
    }

    /* Checks if a given catalog name matches one of our default pre-configured planets,
       returning its index in this.planets or -1. Space-insensitive. */
    _findPlanetIndexByName(name) {
      if (!name) return -1;
      var norm = name.replace(/\s+/g, "").toLowerCase();
      for (var i = 0; i < this.planets.length; i++) {
        var p = this.planets[i];
        if (p.name.replace(/\s+/g, "").toLowerCase() === norm) return i;
      }
      return -1;
    }

    /* Render the panel from this.planets. If search box is empty (click/focus to browse),
       show the tabs (Solar System / DSO) at the top and filter the list below.
       If search box has text (typing), hide the tabs and search across both categories. */
    renderSuggest() {
      if (!this.suggestEl) return;
      this._suggestCleanups?.forEach(function (cleanup) { cleanup(); });
      this._suggestCleanups = [];
      var self = this;
      var q = (this.searchInputEl.value || "").trim().toLowerCase();
      var html = "";

      // Show tabs at the top (always)
      var solarActive = this.suggestCategory === "solar" ? " is-active" : "";
      var dsoActive = this.suggestCategory === "dso" ? " is-active" : "";

      html += '<div class="wo-skyviewer__suggest-tabs">';
      html +=
        '  <button type="button" class="wo-skyviewer__suggest-tab' +
        dsoActive +
        '" data-suggest-cat="dso">DSO</button>';
      html +=
        '  <button type="button" class="wo-skyviewer__suggest-tab' +
        solarActive +
        '" data-suggest-cat="solar">Solar System</button>';
      html += "</div>";

      // When the user opens the box (focus/click) or clicks a tab, we don't apply a text filter.
      // We only filter by query when the user is actively typing.
      var filterQuery = this._isTyping ? q : "";

      // Filter list by category and search query.
      // When typing in DSO tab, we rely entirely on SIMBAD's popularity ordering,
      // so we set items to empty and let SIMBAD drive the suggestion list.
      var items = [];
      if (this.suggestCategory !== "dso" || !filterQuery) {
        items = this.planets
          .map(function (p, i) {
            return { p: p, i: i };
          })
          .filter(function (o) {
            if (o.p.category !== self.suggestCategory) return false;
            if (filterQuery) {
              var nameMatch = o.p.name.toLowerCase().indexOf(filterQuery) >= 0;
              var dispMatch = o.p.displayName && o.p.displayName.toLowerCase().indexOf(filterQuery) >= 0;
              return nameMatch || dispMatch;
            }
            return true;
          });
      }

      // SIMBAD TAP results (DSO tab, typing mode only).
      // _simbadLoading: fetch queued/in-flight; _simbadItems: last result set (undefined = never fetched).
      var simbadItems = [];
      var simbadLoading = false;
      if (this.suggestCategory === "dso" && filterQuery) {
        simbadLoading = !!this._simbadLoading;
        if (!simbadLoading && Array.isArray(this._simbadItems)) {
          simbadItems = this._simbadItems;
        }
      }

      html += '<div class="wo-skyviewer__suggest-list">';
      if (items.length) {
        html += items
          .map(function (o) {
            var sel =
              self.suggestCategory === "dso"
                ? o.p.name === self.activeDsoName
                : o.i === self.planetIndex;

            var label = o.p.displayName || o.p.name;
            var name = o.p.name;
            if (label.indexOf(name) === 0) {
              var sub = label.substring(name.length).trim();
              sub = sub.replace(/^\((.+)\)$/, "$1");
              if (sub) {
                label = name + ' <span class="wo-skyviewer__suggest-sub">' + sub + '</span>';
              }
            }

            return (
              '<button type="button" class="wo-skyviewer__suggest-option' +
              (sel ? " is-active" : "") +
              '" role="option" data-index="' +
              o.i +
              '" aria-selected="' +
              sel +
              '">' +
              label +
              "</button>"
            );
          })
          .join("");
      }
      // 2. Then SIMBAD results (or loading / no-match feedback)
      if (simbadLoading) {
        html += '<div class="wo-skyviewer__suggest-loading">Searching…</div>';
      } else if (simbadItems.length) {
        html += simbadItems
          .map(function (r) {
            var label = r.id;
            var sub = r.commonName;
            if (!sub && r.mainId) {
              var normId = r.id.toLowerCase().replace(/\s+/g, "");
              var normMain = r.mainId.toLowerCase().replace(/\s+/g, "");
              var cleanMain = r.mainId.replace(/^NAME\s+/i, "");
              if (normMain !== normId) {
                sub = cleanMain;
              }
            }
            if (sub) {
              var normLabel = r.id.toLowerCase().replace(/\s+/g, "");
              var normSub = sub.toLowerCase().replace(/\s+/g, "");
              if (normSub !== normLabel) {
                label += ' <span class="wo-skyviewer__suggest-sub">' + sub + '</span>';
              }
            }
            var displayVal = r.id;
            if (r.mainId) {
                if (r.isMainName) {
                    displayVal = r.mainId;
                } else {
                    var catName = r.mainId;
                    var comName = r.commonName;
                    if (!comName) {
                        var normCat = catName.toLowerCase().replace(/\s+/g, "");
                        var normId2 = r.id.toLowerCase().replace(/\s+/g, "");
                        if (normCat !== normId2) comName = r.id;
                    }
                    if (comName) {
                        var normCat2 = catName.toLowerCase().replace(/\s+/g, "");
                        var normCom = comName.toLowerCase().replace(/\s+/g, "");
                        if (normCat2 !== normCom) {
                            displayVal = catName + " (" + comName + ")";
                        } else {
                            displayVal = catName;
                        }
                    } else {
                        displayVal = catName;
                    }
                }
            }

            return (
              '<button type="button" class="wo-skyviewer__suggest-option" role="option" data-catalog-name="' +
              r.id.replace(/"/g, "&quot;") +
              '" data-display-value="' +
              displayVal.replace(/"/g, "&quot;") +
              '" aria-selected="false">' +
              label +
              "</button>"
            );
          })
          .join("");
      } else if (!items.length) {
        // Nothing at all — show "No match" only after SIMBAD has replied (not before first fetch)
        if (this.suggestCategory !== "dso" || Array.isArray(this._simbadItems)) {
          html += '<div class="wo-skyviewer__suggest-empty">No match</div>';
        }
      }
      html += "</div>";

      this.suggestEl.innerHTML = html;
      // Include both static (data-index) and catalog (data-catalog-name) options in keyboard nav.
      this.suggestOptionEls = Array.from(
        this.suggestEl.querySelectorAll("[data-index], [data-catalog-name]"),
      );

      // Highlight the currently active selection if it is in the visible list;
      // otherwise, typing auto-highlights the first match (so Enter picks it) while browsing (empty box) doesn't.
      // planetIndex only tracks the solar scale-ref pick (applyPick never sets it for DSOs, only
      // activeDsoName) — so for the DSO tab, find the active row by name instead, or this always
      // misses and falls through to the "highlight row 0" default below.
      var activeGlobalIdx = -1;
      if (this.suggestCategory === "dso") {
        for (var k = 0; k < items.length; k++) {
          if (items[k].p.name === this.activeDsoName) {
            activeGlobalIdx = items[k].i;
            break;
          }
        }
      } else {
        activeGlobalIdx = this.planetIndex;
      }
      var activeOptIdx = -1;
      if (activeGlobalIdx >= 0) {
        for (var idx = 0; idx < this.suggestOptionEls.length; idx++) {
          if (Number(this.suggestOptionEls[idx].dataset.index) === activeGlobalIdx) {
            activeOptIdx = idx;
            break;
          }
        }
      }

      if (activeOptIdx >= 0) {
        this.suggestActive = activeOptIdx;
      } else {
        // Only auto-highlight the first item if the user is actively typing (typing auto-highlights so Enter picks it).
        // If not typing (browsing/focusing), don't highlight anything by default.
        this.suggestActive = (this._isTyping && q && this.suggestOptionEls.length) ? 0 : -1;
      }
      this.highlightSuggest();

      // Wire up tab buttons
      var tabBtns = this.suggestEl.querySelectorAll("[data-suggest-cat]");
      tabBtns.forEach(function (btn) {
        self.listenSuggest(btn, "click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          // Cancel SIMBAD fetch when leaving the DSO tab
          if (self._simbadTimer) self.cancelScheduled(self._simbadTimer);
          self._simbadLoading = false;
          self._simbadItems = undefined;
          self._isTyping = false; // Reset typing so the new tab shows all items
          self.suggestCategory = btn.dataset.suggestCat;
          // If switching TO DSO tab while input has text, kick off a fresh fetch
          if (self.suggestCategory === "dso") {
            var val = self.searchInputEl ? self.searchInputEl.value.trim() : "";
            if (val) {
              self._isTyping = true;
              self._startSimbadFetch(val);
            }
          }
          self.renderSuggest();
          self.searchInputEl.focus();
        });
      });

      // Wire up options
      this.suggestOptionEls.forEach(function (btn) {
        self.listenSuggest(btn, "click", function (e) {
          e.preventDefault();
          e.stopPropagation(); // Stop propagation to prevent document click listener from closing the search box!
          if (btn.dataset.catalogName !== undefined) {
            // Catalog-generated entry — resolve via Sesame and navigate
            var name = btn.dataset.catalogName;
            var displayVal = btn.dataset.displayValue || name;
            if (self.searchInputEl) self.searchInputEl.value = displayVal;
            self.targetViewMode = "native";
            self.search(name, "catalog");
            self.closeSuggest();
            self.updateFrameVisibility();
          } else {
            var idx = Number(btn.dataset.index);
            self.applyPick(idx); // solar → scale ref; dso → recenter + overlay
          }
        });
      });
    }

    /* ArrowUp/Down move the highlight through visible options; Enter picks the highlighted option,
       else a visible option whose name the text exactly matches (e.g. "Sun"), else falls through
       to the form's Sesame search; Escape closes the panel. */
    onSuggestKey(e) {
      if (e.key === "Escape") {
        if (this.suggestOpen) this.closeSuggest();
        return;
      }
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        if (!this.suggestOpen) {
          this.openSuggest();
          return;
        }
        var els = this.suggestOptionEls || [];
        if (!els.length) return;
        e.preventDefault();
        var dir = e.key === "ArrowDown" ? 1 : -1;
        this.suggestActive =
          (this.suggestActive + dir + els.length) % els.length;
        this.highlightSuggest();
      } else if (e.key === "Enter") {
        var el =
          (this.suggestOptionEls &&
            this.suggestOptionEls[this.suggestActive]) ||
          (this.suggestOpen && this.exactMatchOption());
        if (el) {
          e.preventDefault();
          el.click();
        } // else fall through → form submit (Sesame search)
      }
    }

    /* Apply a picked suggestion by list index. Solar bodies sit on the fixed scale-ref anchor
       (field center) for size comparison; DSOs instead navigate to the real object via search().
       Shared by the form submit and the suggestion-click handlers. */
    applyPick(idx, source) {
      var p = this.planets[idx];
      if (!p) return;
      if (this.searchInputEl) this.searchInputEl.value = p.displayName || p.name;

      var isSolar = p.category === "solar";

      if (isSolar) {
        this.targetViewMode = "planetary";
        var targetFov = p.span / TARGET_FILL_RATIO;
        var viewType = "Planetary";
        if (p.name.toLowerCase() === "sun") {
          viewType = "Solar";
        } else if (p.name.toLowerCase() === "moon") {
          viewType = "Lunar";
        }

        this.setScaleRef(idx);
        if (this.viewer) {
          targetFov = this.probeActualFov(targetFov);
          this.animateFov(targetFov, this.fovAnimDuration);
        } else {
          this.updateFrameVisibility();
        }
      } else if (p.category === "dso") {
        this.targetViewMode = "dso";
        this.activeDsoName = p.name;
        var targetFov = lockedFov(this.activeModel, this.stageMm);

        if (this.viewer) {
          targetFov = this.probeActualFov(targetFov);
          this.animateFov(targetFov, this.fovAnimDuration);
        } else {
          this.updateFrameVisibility();
        }
        this.search(p.name, source || "catalog");
      }

      this.closeSuggest();
      this.updateFrameVisibility();
      this.trackingTarget = {
        targetId: String(p.name).toLowerCase().replace(/[^a-z0-9_-]/g, "_"),
        category: p.category,
      };
      this.emitInteraction("target_selected", {
        targetId: this.trackingTarget.targetId,
        category: this.trackingTarget.category,
      });
    }

    /* Index of the body whose name exactly equals the query, or -1.
       Used by submit to decide: list match → scale ref; no match + solar → blocked;
       no match + dso → Sesame sky search. Checks across all categories. */
    matchedPlanetIndex(query) {
      var q = (query || "").trim().toLowerCase();
      if (!q) return -1;
      for (var i = 0; i < this.planets.length; i++) {
        var p = this.planets[i];
        var nameMatch = p.name.toLowerCase() === q;
        var dispMatch = p.displayName && p.displayName.toLowerCase() === q;
        if (nameMatch || dispMatch) return i;
      }
      return -1;
    }

    /* The visible suggestion whose body name exactly equals the typed text (case-insensitive). */
    exactMatchOption() {
      var v = (this.searchInputEl.value || "").trim().toLowerCase();
      if (!v) return null;
      var self = this;
      return (
        (this.suggestOptionEls || []).filter(function (el) {
          if (el.dataset.catalogName !== undefined) return false;
          var p = self.planets[Number(el.dataset.index)];
          if (!p) return false;
          var name = p.name.toLowerCase();
          var disp = p.displayName ? p.displayName.toLowerCase() : "";
          return name === v || disp === v;
        })[0] || null
      );
    }

    highlightSuggest() {
      var self = this;
      (this.suggestOptionEls || []).forEach(function (el, i) {
        var on = i === self.suggestActive;
        el.classList.toggle("is-highlight", on);
        if (on) el.scrollIntoView({ block: "nearest" });
      });
    }

    failLoader(message) {
      this.showLoaderMessage(message);
    }

    startLoaderSpinner() {
      if (!this.spinnerEl || this.spinnerFrame) return;
      var self = this;
      var start = performance.now();
      this.spinnerEl.style.transformOrigin = "50% 50%";
      var tick = function (now) {
        if (
          !self.spinnerEl ||
          !self.spinnerEl.isConnected ||
          (self.loaderEl && self.loaderEl.classList.contains("is-hidden"))
        ) {
          self.spinnerFrame = null;
          return;
        }
        self.spinnerEl.style.transform =
          "rotate(" + (((now - start) * 0.36) % 360) + "deg)";
        self.spinnerFrame = self.frame(tick);
      };
      this.spinnerFrame = self.frame(tick);
    }

    stopLoaderSpinner() {
      if (this.spinnerFrame) this.cancelScheduled(this.spinnerFrame, "frame");
      this.spinnerFrame = null;
    }

    failureMessage(err) {
      var message = describeError(err);
      if (/WebGL2/i.test(message))
        return "WebGL2 is unavailable in this preview";
      if (
        /initialize WebGL|create WebGL|link WebGL|compile WebGL|shader|#version|unexpected token/i.test(
          message,
        )
      )
        return "WebGL could not initialize in this preview";
      if (
        /Failed to fetch|Load failed|Importing a module script failed|CORS|NetworkError/i.test(
          message,
        )
      )
        return "SkyViewer engine asset could not load";
      if (/not licensed/i.test(message))
        return "SkyViewer is not licensed for this host";
      if (/Image request failed/i.test(message))
        return "Sky tiles could not load";
      return message
        ? "Initialization Failed: " + message.slice(0, 160)
        : "Initialization Failed";
    }

    showLoaderMessage(message) {
      var text =
        this.loaderEl &&
        this.loaderEl.querySelector(".wo-skyviewer__loading-text");
      this.stopLoaderSpinner();
      if (this.spinnerEl) this.spinnerEl.style.display = "none";
      if (text) text.textContent = message;
      if (this.loaderEl) this.loaderEl.classList.remove("is-hidden");
      this.container.setAttribute("aria-busy", "false");
    }

    showEditorNotice() {
      this.showLoaderMessage("Sky preview shows on your live store");
    }

    setActiveIndex(next, opts) {
      opts = opts || {};
      var i = clampIndex(next, this.models.length);
      if (this.validModelIndexes && this.validModelIndexes.indexOf(i) < 0)
        i = this.validModelIndexes[0];
      if (i === this.activeIndex && opts.focusTab !== true) return;

      if (this._fovAnimId) {
        this.cancelScheduled(this._fovAnimId, "frame");
        this._fovAnimId = null;
      }

      var self = this;
      var mode = this.animationMode || "none";
      var duration = this.switchAnimDuration || 400; // ms
      var nextModel = self.models[i];
      var prevModel = self.activeModel;
      var emitModelChange = function () {
        if (prevModel && prevModel.id !== nextModel.id) {
          self.emitInteraction("equipment_changed", {
            previousProductId: String(prevModel.id),
            productId: String(nextModel.id),
          });
        }
      };
      var targetFov = lockedFov(nextModel, self.stageMm);
      if (self.targetViewMode === "planetary" && self.planetIndex >= 0) {
        var p = self.planets[self.planetIndex];
        targetFov = p.span / TARGET_FILL_RATIO;
      }
      targetFov = this.probeActualFov(targetFov);
      if (self.viewer) {
        self.viewer.setMaxFovLimit(targetFov);
      }
      // Commit the model/overlay swap without touching the viewer FOV.
      var commitSwap = function () {
        self.activeIndex = i;
        self.activeModel = nextModel;
        self.updateTabStates();
        self.updateResponsiveContent(self.activeModel);
        self.scrollActiveTabIntoView();
        self.updateOverlay(self.activeModel);
        emitModelChange();
      };

      // Apply the target FOV for non-morph switches and for the end of morph switches.
      var applyTargetFov = function () {
        if (self.viewer) {
          self.viewer.setFovDeg(targetFov);
          self.syncOverlayScale();
        } else {
          self.updateFrameVisibility();
        }
      };

      if (mode === "none") {
        commitSwap();
        applyTargetFov();
      } else if (mode === "morph") {
        // A: Morphing & Scaling — the sky FOV, the image-circle mask, and the SVG frames all
        // tween together off the same ease curve (buildOverlayTween), so the mask can't
        // out-run or lag the focal change in either direction. Tab state / spec text switch
        // immediately (instant UI feedback); only the continuous geometry animates.
        if (this.responsiveContentEl) {
          this.responsiveContentEl.classList.add("is-switching");
        }
        if (this.viewer) {
          var overlayStep = this.buildOverlayTween(prevModel, nextModel, targetFov);
          self.activeIndex = i;
          // Hold self.activeModel as prevModel during the tween so that other layout and
          // scale operations compute against the stable old model, and only commit to nextModel
          // at the end.
          self.updateTabStates();
          self.updateResponsiveContent(nextModel);
          self.scrollActiveTabIntoView();
          self._isFovTweening = true;
          self._pendingNextModel = nextModel;
          this.animateFov(
            targetFov,
            duration,
            function () {
              self._isFovTweening = false;
              self._pendingNextModel = null;
              self.activeModel = nextModel; // Commit nextModel now that the tween has landed
              self.updateOverlay(nextModel); // recomputes frame visibility once, landed on nextModel
              // updateOverlay writes the NOMINAL --circle-edge-pct (as if fully zoomed out to
              // the model's own locked FOV). That's right for a plain switch, but wrong when
              // targetFov came from a planetary/DSO lock (any solar body, not just the Sun):
              // buildOverlayTween's last tween frame left --circle-edge-pct at
              // circleEdgePct(nextModel)/targetScale (correct for the zoomed-in frame), so the
              // nominal value updateOverlay just wrote is a big mismatched jump — the mask
              // balloons open then snaps back down right as the switch lands. syncOverlayScale
              // recomputes it from the real settled FOV, matching the tween's own endpoint.
              self.syncOverlayScale();
              emitModelChange();
            },
            overlayStep,
          );
        } else {
          commitSwap();
          applyTargetFov();
        }
      }

      if (opts.focusTab && self.buttons[i])
        self.buttons[i].focus({ preventScroll: true });

      // Fade in the specs text (remove .is-switching); morph is the only non-"none" mode left.
      if (mode === "morph" && self.responsiveContentEl) {
        self.frame(function () {
          self.frame(function () {
            self.responsiveContentEl.classList.remove("is-switching");
          });
        });
      }
    }

    emitInteraction(eventName, parameters) {
      if (this.isDisposed()) return;
      try {
        if (eventName === "view_changed" && parameters.gesture === "pan") this.trackingTarget = null;
        if (eventName === "target_selected" && this.activeModel) parameters = Object.assign({}, parameters, { productId: String(this.activeModel.id) });
        if (eventName === "equipment_changed") {
          if (this.trackingTarget) parameters = Object.assign({}, parameters, this.trackingTarget);
        }
        window.WOSectionTracking?.track(this.container, eventName, parameters);
      } catch (_) {}
    }

    trackWheel(before, intercepted) {
      if (!this._trackingGesturesReady || this.isDisposed()) return;
      var self = this;
      var tracker = window.WOSectionTracking;
      tracker?.manualView(this.container, "zoom", "start", before.toFixed(5));
      var finish = function () {
        tracker?.manualView(self.container, "zoom", "end", self.viewer.getFovDeg().toFixed(5));
      };
      // Center/limit interception is synchronous; native cursor zoom runs later in propagation.
      if (intercepted) finish();
      else this.frame(finish);
    }

    initTrackingGestures() {
      var self = this;
      var pointers = new Set();
      var snapshot = function () {
        var center = self.viewer.getCenter();
        return { ra: center.ra.toFixed(5), dec: center.dec.toFixed(5), fov: self.viewer.getFovDeg().toFixed(5) };
      };
      var start = null;
      this.listen(this.canvasEl, "pointerdown", function (event) {
        if (!pointers.size) start = snapshot();
        pointers.add(event.pointerId);
      }, { capture: true, passive: true });
      this.listen(this.canvasEl, "pointerup", function (event) {
        pointers.delete(event.pointerId);
        if (pointers.size || !start) return;
        var before = start;
        start = null;
        self.frame(function () {
          var after = snapshot();
          if (JSON.stringify(before) !== JSON.stringify(after)) {
            self.emitInteraction("view_changed", { gesture: before.fov !== after.fov ? "zoom" : "pan" });
          }
        });
      }, { passive: true });
      this.listen(this.canvasEl, "pointercancel", function (event) { pointers.delete(event.pointerId); start = null; }, { passive: true });
      this._trackingGesturesReady = true;
    }

    updateTabStates() {
      var self = this;
      this.buttons.forEach(function (b, i) {
        var sel = i === self.activeIndex;
        b.setAttribute("aria-selected", String(sel));
        b.setAttribute("aria-expanded", String(sel));
        b.tabIndex = sel ? 0 : -1;
      });
      var active = this.buttons[this.activeIndex];
      if (active && this.stageContainerEl) {
        this.stageContainerEl.setAttribute("aria-labelledby", active.id);
      }
    }

    updateResponsiveContent(model) {
      if (this.responsiveContentEl)
        this.responsiveContentEl.innerHTML = this.specMarkup(model);
    }

    specMarkup(model) {
      return (
        "<p>Focal Length: " +
        model.focalLengthMm +
        "mm</p><p>Image Circle: " +
        model.imageCircleMm +
        "mm</p>"
      );
    }

    formatFovVal(deg) {
      if (deg >= 1.0) {
        return deg.toFixed(1) + "°";
      }
      var arcmin = deg * 60;
      if (arcmin >= 1.0) {
        return arcmin.toFixed(1) + "′";
      }
      return (deg * 3600).toFixed(0) + "″";
    }

    probeActualFov(targetFov) {
      if (!this.viewer) return targetFov;
      var oldFov = this.viewer.getFovDeg();
      this.viewer.setFovDeg(targetFov);
      var actual = this.viewer.getFovDeg();
      this.viewer.setFovDeg(oldFov);
      return actual;
    }

    /* onStep(ease): per-frame hook driven by the same ease curve as the FOV tween, so any
       overlay/mask animation the caller wires up lands in lockstep with the focal change.
       Defaults to syncOverlayScale (search/planet fly-to: camera pans within one model, so
       the fov/lockedFov ratio is a valid live scale). Telescope switches pass their own
       tween (see buildOverlayTween) because two different models' geometries are involved. */
    animateFov(targetFov, duration, onComplete, onStep) {
      if (!this.viewer) return;
      var self = this;
      var startFov = this.viewer.getFovDeg();
      var startTime = performance.now();
      if (!onStep) onStep = function () { self.syncOverlayScale(); };

      // Route through interruptFovAnim (not a bare cancelAnimationFrame) so any tween this
      // supersedes — whether it's another fly-to or a morph switch mid-flight — gets its
      // _isFovTweening/_pendingNextModel state cleaned up here, not left orphaned because the
      // cancelled loop's own onComplete never runs. See interruptFovAnim's comment.
      this.interruptFovAnim();

      function step(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / duration, 1);

        var ease = progress * (2 - progress);
        if (self.animationMode === "spring") {
          var c4 = (2 * Math.PI) / 3;
          ease = progress === 0
            ? 0
            : progress === 1
            ? 1
            : Math.pow(2, -6 * progress) * Math.sin((progress * 6 - 0.75) * c4) + 1;
        }

        var currentFov = startFov + (targetFov - startFov) * ease;
        self.viewer.setFovDeg(currentFov);
        onStep(ease);

        if (progress < 1) {
          self._fovAnimId = self.frame(step);
        } else {
          self._fovAnimId = null;
          if (typeof onComplete === "function") onComplete();
        }
      }

      this._fovAnimId = self.frame(step);
    }

    /* Manual mouse/wheel input always wins over a running FOV animation (tab-switch morph,
       planet fly-to, or search fly-to) — otherwise animateFov's per-frame setFovDeg fights the
       user's own pan/zoom, snapping the view back every frame. Called on the first pointerdown
       or wheel tick while _fovAnimId is set. If a morph was mid-flight, finish committing its
       pending model swap so activeIndex/activeModel don't end up mismatched, then resync the
       overlay once to the FOV the interruption landed on. */
    interruptFovAnim() {
      if (!this._fovAnimId) return;
      this.cancelScheduled(this._fovAnimId, "frame");
      this._fovAnimId = null;
      if (this._isFovTweening) {
        this._isFovTweening = false;
        if (this._pendingNextModel) {
          var previousModel = this.activeModel;
          this.activeModel = this._pendingNextModel;
          this._pendingNextModel = null;
          if (previousModel && String(previousModel.id) !== String(this.activeModel.id)) {
            this.emitInteraction("equipment_changed", { previousProductId: String(previousModel.id), productId: String(this.activeModel.id) });
          }
        }
        if (this.responsiveContentEl)
          this.responsiveContentEl.classList.remove("is-switching");
      }
      this.syncOverlayScale();
      this.updateFrameVisibility();
    }

    /* Builds the per-frame overlay tween for a telescope switch: interpolates the mask
       (--circle-edge-pct), the SVG viewBox (frames/labels), and the guide-ring radius from
       whatever is currently on screen to the new model's settled geometry — using the exact
       same target-scale formula syncOverlayScale uses, just evaluated once at the target
       instead of every frame against a mismatched (old fov, new model) pair. That mismatch
       was the bug: mid-switch, currentFov belongs to the old model while the ratio's
       denominator was already the new model's locked FOV, producing a scale with no physical
       meaning that made the mask balloon then settle. A direct value-to-value lerp has no such
       ambiguity and is symmetric in both directions. */
    buildOverlayTween(prevModel, nextModel, targetFov) {
      var self = this;
      var startEdgePct =
        parseFloat(this.canvasShellEl.style.getPropertyValue("--circle-edge-pct")) ||
        circleEdgePct(prevModel, this.stageMm);
      var viewBoxParts = (this.svgEl.getAttribute("viewBox") || "").split(/\s+/);
      var startViewBoxMm = parseFloat(viewBoxParts[2]) || this.stageMm;
      var startCircleR = this.circleEl
        ? parseFloat(this.circleEl.getAttribute("r")) || prevModel.imageCircleMm / 2
        : 0;

      var ref = lockedFov(nextModel, this.stageMm);
      var targetScale = Math.min(targetFov, ref) / ref; // same convention as syncOverlayScale
      var targetEdgePct = circleEdgePct(nextModel, this.stageMm) / targetScale;
      var targetViewBoxMm = this.stageMm * targetScale;
      var targetCircleR = nextModel.imageCircleMm / 2;

      // Planet scale-ruler: like the geometry above, its mm size was frozen at the OLD
      // model's ratio for the whole tween (repositionPlanet only ran once, at the very end),
      // while the viewBox around it kept zooming — so it visibly grew, then jump-corrected
      // to the new model's true size the instant the switch landed. Tween it the same way.
      var rulerIndex = this.planetIndex;
      var startRulerMm = 0;
      var targetRulerMm = 0;
      if (rulerIndex >= 0) {
        var rulerSpan = this.planets[rulerIndex].span;
        // Read the ruler's live on-screen mm first, same as startEdgePct above — if a prior
        // tween was interrupted before landing, self.activeModel (= prevModel here) was never
        // committed to that tween's nextModel, so recomputing from lockedFov(prevModel) alone
        // reconstructs the ORIGINAL stale ratio instead of wherever the ruler actually is now.
        // That mismatch is invisible on --circle-edge-pct (which already reads live) but shows
        // up as the ruler snapping back and reversing direction the instant a second switch
        // interrupts the first.
        startRulerMm =
          (this.planetRulerEl && parseFloat(this.planetRulerEl.getAttribute("width"))) ||
          (rulerSpan * this.stageMm) / lockedFov(prevModel, this.stageMm);
        targetRulerMm = (rulerSpan * this.stageMm) / lockedFov(nextModel, this.stageMm);
      }

      return function (ease) {
        var edgePct = startEdgePct + (targetEdgePct - startEdgePct) * ease;
        self.canvasShellEl.style.setProperty("--circle-edge-pct", edgePct.toFixed(3) + "%");

        var viewBoxMm = startViewBoxMm + (targetViewBoxMm - startViewBoxMm) * ease;
        self.setOverlayViewBox(viewBoxMm);

        if (self.circleEl) {
          self.circleEl.setAttribute("r", String(startCircleR + (targetCircleR - startCircleR) * ease));
        }

        var labelScale = viewBoxMm / self.stageMm;
        if (self.svgEl) {
          self.svgEl.style.setProperty("--label-scale", labelScale.toFixed(4));
        }
        self.sensorLabels.forEach(function (label) {
          var s = SKY_CFG.sensors[label.dataset.label];
          if (s) self.setLabelGeometry(label, s, labelScale);
        });

        if (rulerIndex >= 0 && self.planetRulerEl) {
          var rulerMm = startRulerMm + (targetRulerMm - startRulerMm) * ease;
          self.setPlanetRulerMm(rulerMm);
        }

      };
    }

    updateFrameVisibility() {
      var self = this;
      if (!this.activeModel) return;
      if (this._isFovTweening) return;
      var currentFov = this.viewer
        ? this.viewer.getFovDeg()
        : lockedFov(this.activeModel, this.stageMm);
      var key = currentFov.toFixed(5) + "_" + this.activeIndex;
      if (this._lastVisibilityKey === key) return;
      this._lastVisibilityKey = key;

      var fl = this.activeModel.focalLengthMm;
      var candidates = [];
      var maxCircle = Math.max.apply(null, this.models.map(function(m) { return m.imageCircleMm || 0; }));

      Object.keys(SKY_CFG.sensors).forEach(function (sensorKey) {
        if (sensorKey === "Medium-Format" && maxCircle < 47) return;
        var s = SKY_CFG.sensors[sensorKey];
        var sensorWDeg = fovForMm(s.w, fl);
        var sensorHDeg = fovForMm(s.h, fl);
        var ratio = Math.max(sensorWDeg / currentFov, sensorHDeg / currentFov);

        var isEligible = ratio >= 0.12 && ratio <= 0.9;
        if (isEligible) {
          candidates.push({ key: sensorKey, ratio: ratio });
        }
      });

      candidates.sort(function (a, b) {
        return b.ratio - a.ratio;
      });

      var visibleKeys = candidates.slice(0, 3).map(function (c) {
        return c.key;
      });

      /* If the active frame is no longer visible, hide the overlay */
      if (this._activeFrame && visibleKeys.indexOf(this._activeFrame) < 0) {
        this.hideFrameOverlay();
      }

      this.sensorRects.forEach(function (rect) {
        var sensorKey = rect.dataset.sensor;
        var show = visibleKeys.indexOf(sensorKey) >= 0;
        rect.classList.toggle("is-hidden-frame", !show);
      });

      this.sensorLabels.forEach(function (label) {
        var sensorKey = label.dataset.label;
        var show = visibleKeys.indexOf(sensorKey) >= 0;
        label.classList.toggle("is-hidden-frame", !show);
      });
    }

    updateOverlay(model) {
      var self = this;
      if (this.circleEl)
        this.circleEl.setAttribute("r", String(model.imageCircleMm / 2));
      this.canvasShellEl.style.setProperty(
        "--circle-edge-pct",
        circleEdgePct(model, this.stageMm).toFixed(3) + "%",
      );
      // Labels need the REAL settled scale here, not the nominal (scale=1) default — unlike
      // --circle-edge-pct above (which syncOverlayScale corrects a moment later, same tick,
      // before anything paints), label geometry drives where the label sits inside its sensor
      // frame. On a planetary/DSO-locked landing (targetFov far from lockedFov(model)) the
      // nominal position is way off from the zoomed-in frame syncOverlayScale draws, so the
      // label appears to jump/vanish for a frame before the correction lands. Compute it once,
      // right, using the same formula syncOverlayScale uses.
      var ref = lockedFov(model, this.stageMm);
      var currentFov = Math.min(this.viewer ? this.viewer.getFovDeg() : ref, ref);
      var labelScale = currentFov / ref;
      this.sensorRects.forEach(function (rect) {
        var s = SKY_CFG.sensors[rect.dataset.sensor];
        var supported = (model.formats || []).includes(rect.dataset.sensor);
        self.setRectGeometry(rect, s);
        rect.classList.toggle("supported", supported);
        rect.classList.toggle("reference", !supported);
      });
      this.sensorLabels.forEach(function (label) {
        var s = SKY_CFG.sensors[label.dataset.label];
        var supported = (model.formats || []).includes(label.dataset.label);
        self.setLabelGeometry(label, s, labelScale);
        label.classList.toggle("reference", !supported);
      });
      this.repositionPlanet(); // FOV changed → rescale the ruler to the new locked FOV
      this.hideFrameOverlay(); // model switch → clear any active frame overlay
      this.updateFrameVisibility();
    }

    setRectGeometry(rect, s) {
      rect.setAttribute("x", String(-s.w / 2));
      rect.setAttribute("y", String(-s.h / 2));
      rect.setAttribute("width", String(s.w));
      rect.setAttribute("height", String(s.h));
    }

    setLabelGeometry(label, s, scale) {
      scale = scale || 1.0;
      var inset = (s.short === "Medium-Format" ? 1.25 : 1.1) * scale;
      label.setAttribute("x", "0");
      label.setAttribute("y", String(s.h / 2 - inset));
      label.style.textAnchor = "middle";
    }

    scrollActiveTabIntoView() {
      var active = this.buttons[this.activeIndex];
      if (active) active.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }

    applyFovLock(model) {
      this.setFov(lockedFov(model, this.stageMm));
    }

    /* Rescale the SVG overlay (sensor frames, circle guide, labels, planet ruler) + the CSS
       image-circle mask to the viewer's live FOV so they track zoom. The overlay is drawn in
       focal-plane mm inside the clipped square stage. On-screen angular scale ∝ 1/fov,
       so span = stageMm × (fov / lockedFov). */
    syncOverlayScale() {
      if (!this.viewer || !this.svgEl) return;
      // A tab-switch tween owns the overlay geometry via buildOverlayTween (see
      // setActiveIndex). The engine's "render" event fires on every frame regardless of what
      // triggered the render — including animateFov's own setFovDeg calls during the tween —
      // so without this guard syncOverlayScale runs concurrently with buildOverlayTween and
      // fights it: this.activeModel is already the NEW model (committed at the start of the
      // morph branch) while the FOV is still mid-flight from the OLD model's value, so `ref`
      // and `currentFov` here belong to two different coordinate systems. The resulting
      // scale has no physical meaning and races buildOverlayTween's correct interpolation
      // frame-by-frame — visible as the sky-anchored planet ruler and sensor labels
      // flickering out and snapping back at the wrong size/position mid-switch.
      if (this._isFovTweening) {
        this.hideFrameOverlay();
        return;
      }
      var ref = lockedFov(this.activeModel, this.stageMm);
      var currentFov = Math.min(this.viewer.getFovDeg(), ref);
      var scale = currentFov / ref; // >1 zoomed out, <1 zoomed in
      var w = this.stageMm * scale;
      var key = w + "_" + this.activeIndex;
      if (this._lastOverlayKey === key) return;
      this._lastOverlayKey = key;
      this.setOverlayViewBox(w);
      // Image-circle vignette grows/shrinks with the same scale to stay matched to the frames.
      this.canvasShellEl.style.setProperty(
        "--circle-edge-pct",
        (circleEdgePct(this.activeModel, this.stageMm) / scale).toFixed(3) +
          "%",
      );

      var self = this;
      // Scale label fonts and stroke widths to maintain constant screen size
      this.svgEl.style.setProperty("--label-scale", scale.toFixed(4));
      this.sensorLabels.forEach(function (label) {
        var s = SKY_CFG.sensors[label.dataset.label];
        if (s) {
          self.setLabelGeometry(label, s, scale);
        }
      });

      /* Keep frame overlay text sized correctly after zoom */
      this.refreshFrameOverlay();

      this.updateFrameVisibility();
    }

    setOverlayViewBox(spanMm) {
      if (!this.svgEl) return;
      var half = spanMm / 2;
      this.svgEl.setAttribute(
        "viewBox",
        -half + " " + -half + " " + spanMm + " " + spanMm,
      );
    }

    /* ─── Frame Triangle Overlay ─── */

    /* Create SVG elements for the frame hover/tap triangle mask + dimension text.
       All elements start hidden (display:none). Appended to the overlay SVG so they
       render on top of the sensor frames. */
    initFrameOverlay() {
      if (!this.svgEl) return;
      var self = this;
      var svgNS = "http://www.w3.org/2000/svg";

      /* Triangle polygon — semi-transparent black fill, no stroke */
      this._frameTriEl = document.createElementNS(svgNS, "polygon");
      this._frameTriEl.setAttribute("fill", "rgba(0,0,0,0.6)");
      this._frameTriEl.setAttribute("stroke", "none");
      this._frameTriEl.classList.add("wo-skyviewer__frame-overlay-anim");
      this._frameTriEl.style.pointerEvents = "none";
      this.svgEl.appendChild(this._frameTriEl);

      /* Inner dimension text (two lines: W×H mm / Diagonal mm) */
      this._frameDimEl = document.createElementNS(svgNS, "text");
      this._frameDimEl.classList.add("wo-skyviewer__frame-overlay-anim");
      this._frameDimEl.style.pointerEvents = "none";
      this._frameDimEl.setAttribute("fill", "rgba(255,255,255,1)");
      this._frameDimEl.setAttribute("dominant-baseline", "hanging");
      this._frameDimEl.setAttribute("text-anchor", "start");
      this._frameDimEl.classList.add("wo-skyviewer__sensor-label");
      this._frameDimEl.classList.add("wo-skyviewer__frame-dim-label");
      this.svgEl.appendChild(this._frameDimEl);

      /* "Out of Image Circle" text for dashed/reference frames */
      this._frameOocEl = document.createElementNS(svgNS, "text");
      this._frameOocEl.classList.add("wo-skyviewer__frame-overlay-anim");
      this._frameOocEl.style.pointerEvents = "none";
      this._frameOocEl.setAttribute("fill", "rgba(255,255,255,1)");
      this._frameOocEl.setAttribute("dominant-baseline", "auto");
      this._frameOocEl.setAttribute("text-anchor", "middle");
      this._frameOocEl.classList.add("wo-skyviewer__sensor-label");
      this.svgEl.appendChild(this._frameOocEl);

      /* Attach pointer listeners to the stage container so the canvas still
         receives pan/zoom events (the SVG overlay has pointer-events:none). */
      var stageEl = this.stageContainerEl;
      if (!stageEl) return;

      self._activePointers = new Map();
      self._isMultiTouch = false;

      self.listen(stageEl, "pointerdown", function (e) {
        self._activePointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        /* Pinch-zoom / multi-touch gesture starts when more than one pointer is active */
        if (self._activePointers.size > 1) {
          self._isMultiTouch = true;
          self.hideFrameOverlay();
          self._framePointerStartPos = null;
          return;
        }

        self._framePointerStartPos = { x: e.clientX, y: e.clientY };
        self._framePointerMoved = false;

        // Hide overlay immediately when dragging/panning starts
        self.hideFrameOverlay();
      }, { passive: true });

      self.listen(stageEl, "pointermove", function (e) {
        if (self._activePointers.has(e.pointerId)) {
          self._activePointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        }

        /* Skip overlay logic if multi-touch gesture is currently active */
        if (self._isMultiTouch) return;

        /* Track drag distance for mobile tap vs. drag */
        if (self._framePointerStartPos) {
          var dx = e.clientX - self._framePointerStartPos.x;
          var dy = e.clientY - self._framePointerStartPos.y;
          var dragThresholdPx = 9;
          if (dx * dx + dy * dy > dragThresholdPx * dragThresholdPx)
            self._framePointerMoved = true;
        }

        /* Desktop hover: only for mouse pointer */
        if (e.pointerType !== "mouse") return;
        if (self.suggestOpen) return;
        if (self._framePointerStartPos) return;

        var hit = self.hitTestLabel(e.clientX, e.clientY, e.pointerType);
        if (hit !== self._activeFrame) {
          if (hit) {
            self.showFrameOverlay(hit);
            stageEl.style.cursor = "default";
          } else {
            self.hideFrameOverlay();
            stageEl.style.cursor = "";
          }
        }
      }, { passive: true });

      self.listen(stageEl, "pointerleave", function (e) {
        if (e.pointerType !== "mouse") return;
        stageEl.style.cursor = "";
        if (self._activeFrame) self.hideFrameOverlay();
      }, { passive: true });

      self.listen(stageEl, "pointerup", function (e) {
        self._activePointers.delete(e.pointerId);

        /* Handle release of multi-touch pointers */
        if (self._isMultiTouch) {
          if (self._activePointers.size === 0) {
            self._isMultiTouch = false;
          }
          self._framePointerStartPos = null;
          return;
        }

        /* Mobile tap: only for touch pointer */
        if (e.pointerType !== "touch") {
          self._framePointerStartPos = null;
          return;
        }

        /* Skip overlay trigger if select/suggest panel is open */
        if (self.suggestOpen) {
          self._framePointerStartPos = null;
          return;
        }

        /* If the pointer moved (drag), don't trigger */
        if (self._framePointerMoved) {
          self._framePointerStartPos = null;
          return;
        }
        self._framePointerStartPos = null;

        var hit = self.hitTestLabel(e.clientX, e.clientY, e.pointerType);
        if (!hit) {
          /* Tap on empty area → dismiss */
          if (self._activeFrame) self.hideFrameOverlay();
        } else if (hit === self._activeFrame) {
          /* Tap same frame → dismiss */
          self.hideFrameOverlay();
        } else {
          /* Tap different frame → switch */
          self.showFrameOverlay(hit);
        }
      }, { passive: true });

      /* Also dismiss on pointercancel (e.g. interrupted gesture) */
      self.listen(stageEl, "pointercancel", function (e) {
        self._activePointers.delete(e.pointerId);
        if (self._activePointers.size === 0) {
          self._isMultiTouch = false;
        }
        self._framePointerStartPos = null;
        self._framePointerMoved = false;
      }, { passive: true });
    }

    /* Convert screen (client) coordinates to SVG viewBox mm coordinates. */
    screenToSvgMm(clientX, clientY) {
      if (!this.svgEl) return null;
      var ctm = this.svgEl.getScreenCTM();
      if (!ctm) return null;
      var inv = ctm.inverse();
      return {
        x: inv.a * clientX + inv.c * clientY + inv.e,
        y: inv.b * clientX + inv.d * clientY + inv.f,
      };
    }

    /* Hit-test the frame text labels. Returns the sensor key if the pointer is within
       the label's bounding box (with optional slop/padding for easier tapping/hovering). */
    hitTestLabel(clientX, clientY, pointerType) {
      if (!this.svgEl) return null;
      var hit = null;

      this.sensorLabels.forEach(function (label) {
        if (label.classList.contains("is-hidden-frame")) return;

        var rect = label.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;

        var slop = pointerType === "touch" ? 12 : 4;
        if (clientX >= rect.left - slop && clientX <= rect.right + slop &&
            clientY >= rect.top - slop && clientY <= rect.bottom + slop) {
          hit = label.dataset.label;
        }
      });

      return hit;
    }

    /* Show the triangle mask + dimension text for the given sensor key. */
    showFrameOverlay(sensorKey) {
      if (!this._frameTriEl || !this._frameDimEl || !this._frameOocEl) return;

      var rect = null;
      for (var i = 0; i < this.sensorRects.length; i++) {
        if (this.sensorRects[i].dataset.sensor === sensorKey) {
          rect = this.sensorRects[i];
          break;
        }
      }
      /* If the frame is hidden, do not show/draw the overlay */
      if (rect && rect.classList.contains("is-hidden-frame")) {
        this.hideFrameOverlay();
        return;
      }

      this._activeFrame = sensorKey;

      var s = SKY_CFG.sensors[sensorKey];
      if (!s) return;
      var hw = s.w / 2, hh = s.h / 2;

      /* Triangle vertices (inside frame): aligned exactly to frame borders (top-left, bottom-left, top-right) */
      var p1 = (-hw) + "," + (-hh);
      var p2 = (-hw) + "," + (hh);
      var p3 = (hw) + "," + (-hh);
      this._frameTriEl.setAttribute("points", p1 + " " + p2 + " " + p3);
      this._frameTriEl.classList.add("is-visible");

      var isReference = rect && rect.classList.contains("reference");

      /* Maintain pure white overlay text by explicitly removing reference class (no opacity reduction). */
      this._frameDimEl.classList.remove("reference");

      var wVal = Math.round(s.w);
      var hVal = Math.round(s.h);
      var diagVal = Math.round(Math.sqrt(s.w * s.w + s.h * s.h));

      /* Position inside the top-left corner of the mask using a wider font-size tied offset. */
      var scale = this.svgEl ? parseFloat(this.svgEl.style.getPropertyValue("--label-scale")) || 1 : 1;
      var fontSizeBase = (window.innerWidth <= 640 ? 2.0 : 1.275);
      var fontMm = fontSizeBase * scale;
      var textPadding = fontMm * 1.1;
      var textX = -hw + textPadding;
      var textY = -hh + textPadding;

      this._frameDimEl.setAttribute("x", String(textX));
      this._frameDimEl.setAttribute("y", String(textY));
      this._frameDimEl.style.textAnchor = "start";
      this._frameDimEl.style.dominantBaseline = "auto";

      /* Clean styles: no shadows, strokes, or outline styling. Plain text matching stylesheet. */
      this._frameDimEl.removeAttribute("font-size");
      this._frameDimEl.style.fontFamily = "";
      this._frameDimEl.style.fontWeight = "";
      this._frameDimEl.style.letterSpacing = "";
      this._frameDimEl.style.paintOrder = "";
      this._frameDimEl.style.stroke = "";
      this._frameDimEl.style.strokeWidth = "";
      this._frameDimEl.style.strokeLinejoin = "";

      var html = '<tspan x="' + textX + '" dy="0.9em">' + wVal + " \u00D7 " + hVal + " mm" + "</tspan>";
      html += '<tspan x="' + textX + '" dy="1.4em">Diagonal ' + diagVal + " mm</tspan>";
      if (isReference) {
        html += '<tspan x="' + textX + '" dy="1.8em" fill="#ef4444">Out of Image Circle</tspan>';
      }
      this._frameDimEl.innerHTML = html;
      this._frameDimEl.classList.add("is-visible");

      /* Out of Image Circle standalone text is now merged into _frameDimEl, keep original hidden */
      this._frameOocEl.classList.remove("is-visible");
    }

    /* Hide the frame overlay — clears triangle, text, and state. */
    hideFrameOverlay() {
      if (this._frameTriEl) this._frameTriEl.classList.remove("is-visible");
      if (this._frameDimEl) this._frameDimEl.classList.remove("is-visible");
      if (this._frameOocEl) this._frameOocEl.classList.remove("is-visible");
      this._activeFrame = null;
    }

    /* Re-render the frame overlay text sizing when the overlay scale changes (zoom). */
    refreshFrameOverlay() {
      if (this._activeFrame) this.showFrameOverlay(this._activeFrame);
    }


    onTabKeydown(e) {
      var dirs = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      var len = this.models.length;
      if (e.key in dirs) {
        e.preventDefault();
        this.setActiveIndex((this.activeIndex + dirs[e.key] + len) % len, {
          focusTab: true,
        });
      } else if (e.key === "Home") {
        e.preventDefault();
        this.setActiveIndex(0, { focusTab: true });
      } else if (e.key === "End") {
        e.preventDefault();
        this.setActiveIndex(len - 1, { focusTab: true });
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.setActiveIndex(Number(e.currentTarget.dataset.index), {
          focusTab: true,
        });
      }
    }
  }

  var viewerInstances = new Map();

  function initWoSkyviewers(root) {
    var scope = root || document;
    var elements = Array.from(scope.querySelectorAll("[data-wo-skyviewer-viewer]"));
    if (scope.matches?.("[data-wo-skyviewer-viewer]")) elements.unshift(scope);
    elements.forEach(function (el) {
        if (el.dataset.initialized) return;
        try {
          var instance = new WoSkyviewer(el);
          viewerInstances.set(el, instance);
          el.dataset.initialized = "true";
        } catch (err) {
          // Leave the section uninitialized; the loader's own timeout surfaces the failure.
        }
      });
  }

  document.addEventListener("shopify:section:unload", function (event) {
    viewerInstances.forEach(function (instance, el) {
      if (event.target === el || event.target.contains(el)) {
        instance.dispose();
        viewerInstances.delete(el);
      }
    });
  });

  window.__woSkyviewerInitSections = initWoSkyviewers;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initWoSkyviewers();
    });
  } else {
    initWoSkyviewers();
  }
  document.addEventListener("shopify:section:load", function (e) {
    initWoSkyviewers(e.target);
  });
})();
